query CommonDataOnAppLoading {
  userPendingApprovalCount
}